import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PeopleIcon from '@mui/icons-material/People';
import StoreMallDirectoryIcon from '@mui/icons-material/StoreMallDirectory';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import { CatalogStats } from '../api/statsApi';

interface FooterProps {
  setCategoriaSeleccionada?: (cat: string) => void;
  setMostrarProductos?: (show: boolean) => void;
  stats?: CatalogStats | null;
}

const Footer: React.FC<FooterProps> = ({ setCategoriaSeleccionada, setMostrarProductos, stats }) => {
  const navigate = useNavigate();
  const formatStat = (value?: number) => (value ?? 0).toLocaleString('es-MX');

  const goToCategory = (cat: string) => {
    setCategoriaSeleccionada && setCategoriaSeleccionada(cat);
    setMostrarProductos && setMostrarProductos(true);
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'auto' });
  };

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#1a1a1a',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'grid', 
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, 
          gap: 4 
        }}>
          {/* Contacto */}
          <Box>
            <Typography variant="h6" gutterBottom sx={{ color: '#4caf50', fontWeight: 'bold' }}>
              Contacto
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {/* Teléfonos */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PhoneIcon sx={{ color: '#4caf50', fontSize: 20 }} />
                <Link href="tel:+526622055654" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4caf50' } }}>
                  (+52)-662-2055-654
                </Link>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PhoneIcon sx={{ color: '#4caf50', fontSize: 20 }} />
                <Link href="tel:+526311160671" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4caf50' } }}>
                  (+52)-631-1160-671
                </Link>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PhoneIcon sx={{ color: '#4caf50', fontSize: 20 }} />
                <Link href="tel:+526311130131" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4caf50' } }}>
                  (+52)-631-1130-131
                </Link>
              </Box>
              {/* Correos */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon sx={{ color: '#4caf50', fontSize: 20 }} />
                <Link href="mailto:admi.elpoderoso@gmail.com" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4caf50' } }}>
                  admi.elpoderoso@gmail.com
                </Link>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon sx={{ color: '#4caf50', fontSize: 20 }} />
                <Link href="mailto:Jose_Jaan@hotmail.com" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4caf50' } }}>
                  Jose_Jaan@hotmail.com
                </Link>
              </Box>
              {/* Ciudades */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOnIcon sx={{ color: '#4caf50', fontSize: 20 }} />
                <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                  H. Nogales, Sonora, México
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOnIcon sx={{ color: '#4caf50', fontSize: 20 }} />
                <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                  Tijuana, Baja California Norte, México
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <AccessTimeIcon sx={{ color: '#4caf50', fontSize: 20 }} />
                <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                  Lun-Vie: 8:00 - 18:00
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Categorías */}
          <Box>
            <Typography variant="h6" gutterBottom sx={{ color: '#4caf50', fontWeight: 'bold' }}>
              Categorías
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link component="button" onClick={() => goToCategory('insectos-aranas')} sx={{ color: '#b0b0b0', textAlign: 'left', textDecoration: 'none', '&:hover': { color: '#4caf50' } }}>
                Insectos y Arañas
              </Link>
              <Link component="button" onClick={() => goToCategory('roedores')} sx={{ color: '#b0b0b0', textAlign: 'left', textDecoration: 'none', '&:hover': { color: '#4caf50' } }}>
                Roedores
              </Link>
              <Link component="button" onClick={() => goToCategory('jardin')} sx={{ color: '#b0b0b0', textAlign: 'left', textDecoration: 'none', '&:hover': { color: '#4caf50' } }}>
                Jardín
              </Link>
              <Link component="button" onClick={() => goToCategory('mascotas')} sx={{ color: '#b0b0b0', textAlign: 'left', textDecoration: 'none', '&:hover': { color: '#4caf50' } }}>
                Mascotas
              </Link>
              <Link component="button" onClick={() => goToCategory('uso-humano')} sx={{ color: '#b0b0b0', textAlign: 'left', textDecoration: 'none', '&:hover': { color: '#4caf50' } }}>
                Uso Humano
              </Link>
              <Link component="button" onClick={() => goToCategory('limpieza-desinfeccion')} sx={{ color: '#b0b0b0', textAlign: 'left', textDecoration: 'none', '&:hover': { color: '#4caf50' } }}>
                Limpieza
              </Link>
              <Link component="button" onClick={() => goToCategory('auto-hogar')} sx={{ color: '#b0b0b0', textAlign: 'left', textDecoration: 'none', '&:hover': { color: '#4caf50' } }}>
                Auto y Hogar
              </Link>
            </Box>
          </Box>

          {/* Quiénes somos, Visión y Misión */}
          <Box>
            <Typography variant="h6" gutterBottom sx={{ color: '#4caf50', fontWeight: 'bold' }}>
              Quiénes Somos
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: '#b0b0b0' }}>
              Defender: Líder en productos insecticidas y de control de plagas desde 2016. Calidad garantizada para proteger su hogar y negocio.
            </Typography>
            <Typography variant="subtitle2" sx={{ color: '#4caf50', fontWeight: 'bold', mt: 2 }}>
              Visión
            </Typography>
            <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
              Ser la empresa líder en soluciones de control de plagas y productos de limpieza en México, reconocida por su calidad y servicio.
            </Typography>
            <Typography variant="subtitle2" sx={{ color: '#4caf50', fontWeight: 'bold', mt: 2 }}>
              Misión
            </Typography>
            <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
              Proteger hogares y negocios ofreciendo productos efectivos, seguros y un servicio excepcional a nuestros clientes.
            </Typography>
          </Box>

          {/* Redes Sociales */}
          <Box>
            <Typography variant="h6" gutterBottom sx={{ color: '#4caf50', fontWeight: 'bold' }}>
              Redes Sociales
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <MusicNoteIcon sx={{ color: '#4caf50', fontSize: 28 }} aria-label="TikTok" />
              <InstagramIcon sx={{ color: '#4caf50', fontSize: 28 }} aria-label="Instagram" />
              <FacebookIcon sx={{ color: '#4caf50', fontSize: 28 }} aria-label="Facebook" />
            </Box>
          </Box>
        </Box>

        {/* Estadísticas de la empresa */}
        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
          alignItems: 'center',
          gap: { xs: 2, sm: 4 },
          mt: 5,
          mb: 2,
        }}>
          <Box sx={{ textAlign: 'center', p: 2, borderRadius: 2, bgcolor: 'rgba(76, 175, 80, 0.08)', border: '1px solid rgba(76, 175, 80, 0.25)', minWidth: { xs: '180px', sm: '160px' }, color: '#b0b0b0' }}>
            <PeopleIcon sx={{ color: '#4caf50', fontSize: 32, mb: 1 }} />
            <Typography variant="h6" color="#4caf50" fontWeight="bold">{formatStat(stats?.clientesActivos)}</Typography>
            <Typography variant="body2">Clientes Activos</Typography>
          </Box>
          <Box sx={{ textAlign: 'center', p: 2, borderRadius: 2, bgcolor: 'rgba(76, 175, 80, 0.08)', border: '1px solid rgba(76, 175, 80, 0.25)', minWidth: { xs: '180px', sm: '160px' }, color: '#b0b0b0' }}>
            <StoreMallDirectoryIcon sx={{ color: '#4caf50', fontSize: 32, mb: 1 }} />
            <Typography variant="h6" color="#4caf50" fontWeight="bold">{formatStat(stats?.sucursalesActivas)}</Typography>
            <Typography variant="body2">Sucursales Activas</Typography>
          </Box>
          <Box sx={{ textAlign: 'center', p: 2, borderRadius: 2, bgcolor: 'rgba(76, 175, 80, 0.08)', border: '1px solid rgba(76, 175, 80, 0.25)', minWidth: { xs: '180px', sm: '160px' }, color: '#b0b0b0' }}>
            <LocationCityIcon sx={{ color: '#4caf50', fontSize: 32, mb: 1 }} />
            <Typography variant="h6" color="#4caf50" fontWeight="bold">{formatStat(stats?.ciudadesActivas)}</Typography>
            <Typography variant="body2">Ciudades Activas</Typography>
          </Box>
          <Box sx={{ textAlign: 'center', p: 2, borderRadius: 2, bgcolor: 'rgba(76, 175, 80, 0.08)', border: '1px solid rgba(76, 175, 80, 0.25)', minWidth: { xs: '180px', sm: '160px' }, color: '#b0b0b0' }}>
            <Inventory2Icon sx={{ color: '#4caf50', fontSize: 32, mb: 1 }} />
            <Typography variant="h6" color="#4caf50" fontWeight="bold">{formatStat(stats?.productosEnVenta)}</Typography>
            <Typography variant="body2">Productos en Venta</Typography>
          </Box>
        </Box>

        {/* Línea divisoria */}
        <Box sx={{ borderTop: '1px solid #333', mt: 4, pt: 3 }}>
          <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', sm: 'row' }, 
            justifyContent: 'space-between', 
            alignItems: { xs: 'flex-start', sm: 'center' },
            gap: 2
          }}>
            <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
              © 2024 SoftAvelar. Todos los derechos reservados.
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Link href="#" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4caf50' } }}>
                Política de Privacidad
              </Link>
              <Link href="#" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4caf50' } }}>
                Términos de Servicio
              </Link>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 